export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q03_b.e1790a76.png";